import { OBJECT_ENGAGEMENTS_SUMMARY, OBJECT_SUMMARY } from 'copilot-toolkit/constants/CopilotInAppActionTypes';
import { safeParseJson } from '../chat/utils/jsonUtil';
import Raven from 'raven-js';

/**
 * Parses stringified copilot action data and returns the appropriate InAppCopilotAction object
 * based on the intent. Currently supports OBJECT_SUMMARY and OBJECT_ENGAGEMENT_SUMMARY.
 *
 * @param actionDataString - The stringified action data from navigation components
 * @returns InAppCopilotAction object or null if parsing fails or intent is not supported
 *
 * @example
 * // For object engagement summary
 * const actionString = JSON.stringify({
 *   intent: 'object_engagements_summary',
 *   objectId: '12345',
 *   objectType: 'contact',
 *   context: { engagementTypes: 'meetings' }
 * });
 *
 * const action = parseCopilotActionData(actionString);
 * // Returns: { intent: 'object_engagements_summary', objectId: '12345', objectType: 'contact', context: {...} }
 */
export const parseCopilotActionData = actionDataString => {
  const parsedData = safeParseJson(actionDataString);
  if (!parsedData || !parsedData.intent) {
    Raven.captureException(new Error('Invalid action data: missing intent'));
    return null;
  }
  const intent = parsedData.intent;
  switch (intent) {
    case OBJECT_ENGAGEMENTS_SUMMARY:
      return {
        intent: OBJECT_ENGAGEMENTS_SUMMARY,
        objectId: parsedData.objectId,
        objectType: parsedData.objectType,
        context: {}
      };
    case OBJECT_SUMMARY:
      return {
        intent: OBJECT_SUMMARY,
        objectId: parsedData.objectId,
        objectTypeId: parsedData.objectTypeId,
        objectTypeLabel: parsedData.objectTypeLabel,
        objectName: parsedData.objectName,
        label: parsedData.label,
        summaryType: parsedData.summaryType
      };
    default:
      Raven.captureMessage(`Unsupported copilot action intent: ${intent}`);
      return null;
  }
};